import apiClient from './api';

const authService = {
  register: async (data) => {
    return apiClient.post('/auth/register', data);
  },

  login: async (username, password) => {
    const response = await apiClient.post('/auth/login', {
      username,
      password,
    });
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  getProfile: async () => {
    return apiClient.get('/auth/profile');
  },

  updateProfile: async (data) => {
    return apiClient.put('/auth/profile', data);
  },

  changePassword: async (data) => {
    return apiClient.post('/auth/change-password', data);
  },

  createAdmin: async (data) => {
    return apiClient.post('/auth/create-admin', data);
  },
};

export default authService;
